export default {
  resource:{
    zh: {
      companyNo:"公司",
      companyName:"公司",
      deptNo:"部门",
      deptName:"部门",
      job:"岗位",
      basePay:"基本工资",
      jobPay:"岗位工资",
      meritsPay:"绩效奖",
      fullAttdPay:"全勤奖",
      restDays:"工休",
      restType_2:"每周六、日",
      restType_1:"每周日",
      restType0:"无",
      restType1:"1天",
      restType2:"2天",
      restType3:"3天",
      restType4:"4天",
      restType5:"5天",
      restType6:"6天",
      restType7:"7天",
      restType8:"8天",
      foodSubsidy: "伙食补贴",
      remark: "备注",
      jobSubsidy:"岗位薪贴",
      OTSubsidy: "加班薪贴",
      restDaysSubsidy: "无工休薪贴",
      holidaySubsidy: "法定假日薪贴",
      senioritySubsidy: "工龄奖",
      otherSubsidy: "其他薪贴",
      sname:"计薪方法",
      workMonthPay: "工龄奖(每月)",
      hotPay:"高温补贴(每天)",
      socialSecurity:"社保基数"
    }

  },
  delConf:["deptName", "job"],
  delKeys:["autoid"],
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Contains",
      type: "select",
      options:"company"
    },
    deptName:{
      key: "deptName",
      data: null,
      method: "Equal",
      type: "text"
    },
    job:{
      key: "job",
      data: null,
      method: "Equal",
      type: "text"
    }
  },
  listDefine: [
    "companyName", "deptName", "job", "basePay", 'jobPay', 'meritsPay', 'fullAttdPay',
    { key: 'restDays', formatter: "frd" }
    , 'foodSubsidy', "workMonthPay", "hotPay", "socialSecurity", 'sname', "remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"deptName",
  defaultSortOrder:"asc",
  sortName: "deptName",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "JobSalary/",
  autoId: "autoid",
  formatter: {
    fsex(t) {
      return 'sex' + t
    },
    fstatus(t) {
      return 'status' + t
    },
    frd(t) {
      if (!t) return "restType0" 
      if(parseInt(t) == -1) {
        return "restType_1"
      } else if(parseInt(t) == -2) {
        return "restType_2"
      }
      return "restType" + t
    }
  }

}
